<script setup lang="ts">
import { sideConfig } from '@/lib/product'

/**
 * The label that opens a side's section: the side's icon and name in its own accent,
 * then a rule filling the row.
 *
 * Five components had rendered this by hand from `sideConfig`, which is how the two
 * text sizes and the one card that spells "Trade In" without the hyphen crept in.
 * `title` overrides the side's own label where a card names its section for what it
 * shows rather than for the side.
 */
withDefaults(
    defineProps<{
        side: 'resell' | 'buyback'
        title?: string
        /** `sm` on a card header, `xs` inside a card's body. */
        size?: 'sm' | 'xs'
    }>(),
    {
        title: undefined,
        size: 'xs',
    },
)
</script>

<template>
    <div class="flex items-center gap-2" :class="sideConfig[side].accent.text">
        <component :is="sideConfig[side].icon" class="size-4" />
        <span class="font-semibold uppercase tracking-wider" :class="size === 'sm' ? 'text-sm' : 'text-xs'">
            {{ title ?? sideConfig[side].label }}
        </span>
        <slot />
        <div class="h-px flex-1" :class="sideConfig[side].accent.rule" />
    </div>
</template>
